/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();
    const newProductId = typeof productId === 'object' && productId !== null ? productId.id : productId;
    const existingProduct = viewedProducts.find((product) => {
      const id = typeof product === 'object' && product !== null ? product.id : product;
      return String(id) === String(newProductId);
    });
    const productToStore = existingProduct || productId;

    viewedProducts = viewedProducts.filter((product) => {
      const id = typeof product === 'object' && product !== null ? product.id : product;
      return String(id) !== String(newProductId);
    });
    viewedProducts.unshift(productToStore);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static getProductIds() {
    return this.getProducts()
      .map((product) => (typeof product === 'object' && product !== null ? product.id : product))
      .filter(Boolean);
  }
}
